import { useEffect, useMemo, useState } from "react"
import { Link } from "react-router-dom"
import { Input, Button, Table, Space, Select } from 'antd'
import { SearchOutlined, RedoOutlined } from '@ant-design/icons'
import { axiosTable } from "../../tool/axios"
import { SelectStores } from "../../component/common/Selects"
import { CheckImgs } from "../../component/common/Imgs"
import BreadCrumb from '../../component/BreadCrumb'
import getPermission from '../../js/permission'
import _ from 'lodash'

const { Column } = Table
const { Option } = Select

type fetchParams = {
    store_id: string | undefined,
    user_name: string | undefined,
    phone: string | undefined,
    in_out: number | undefined,
    coperation_id: string | undefined,
    status: number | undefined,
    work_status: number | undefined
}

type pagination = {
    current: number,
    pageSize: number,
    total: number,
    showSizeChanger: boolean
}

export default function IndexNew() {

    let fetchOtherParamsTmpl: fetchParams = {
        store_id: undefined,
        user_name: undefined,
        phone: undefined,
        in_out: undefined,
        coperation_id: undefined,
        status: undefined,
        work_status: undefined
    }

    const [pagination, setPagination] = useState<pagination>({
        current: 1,
        pageSize: 8,
        total: 0,
        showSizeChanger: false
    })

    const [fetchOtherParams, setFetchOtherParams] = useState<fetchParams>(fetchOtherParamsTmpl)
    // 列表数据
    const [data, setData] = useState<any>([])
    const [data2, setData2] = useState<any>([])

    const [loading, setLoading] = useState<boolean>(false)
    const [coperationList, setCoperationList] = useState<any>([])

    const [imageType, setImageType] = useState<string>('')
    const [imageList, setImageList] = useState<any[]>([])
    const [imageVisble, setImageVisble] = useState<boolean>(false)

    // 用户权限
    const permission: string[] = useMemo(() => {
        return getPermission()
    }, [window.location.pathname])

    useEffect(() => {
        fetch({ pagination, fetchOtherParams })
    }, [pagination.current])

    useEffect(() => {
        // 查看合作商列表
        axiosTable.get("/yuesao_center/global/coperation_list", {

        }).then((response: any) => {
            if (response) {
                setCoperationList(response)
            }
        })

        summaryFetch({ fetchOtherParams })
    }, [])

    const handleChange = (value: any, attr: string) => {
        let params: any = _.cloneDeep(fetchOtherParams)
        params[attr] = value

        setFetchOtherParams(params)
    }

    const handleSearch = () => {
        const p = { ...pagination }
        p.current = 1

        fetch({ pagination: p, fetchOtherParams })
        summaryFetch({ fetchOtherParams })
    }

    const handleTableChange = (antPagination: any) => {
        const p = { ...pagination }
        p.current = antPagination.current

        setPagination(p)
    }

    const handleUrl = (el: any, type: any) => {
        if (type == '1') {
            setImageList(el.head_pic_url ? el.head_pic_url.split(',') : [])

        } else if (type == '2') {
            setImageList(el.cert_pic_url ? el.cert_pic_url.split(',') : [])

        } else if (type == '3') {
            setImageList(el.check_report_url ? el.check_report_url.split(',') : [])

        } else if (type == '4') {
            setImageList(el.service_diet_url ? el.service_diet_url.split(',') : [])

        } else {
            setImageList(el.service_photo_url ? el.service_photo_url.split(',') : [])
        }

        setImageType(type)
        setImageVisble(true)
    }

    const fetch = ({ pagination, fetchOtherParams }: { pagination: Object, fetchOtherParams: object }) => {
        let iPagination: any = { ...pagination }
        iPagination.page_num = iPagination.current
        iPagination.page_size = iPagination.pageSize

        delete iPagination.current
        delete iPagination.pageSize
        delete iPagination.total

        axiosTable.get('/yuesao_center/manage/archives/page_list', {
            params: {
                ...iPagination,
                ...fetchOtherParams
            }

        }).then((response: any) => {
            if (response) {
                let p: any = { ...pagination }
                p.total = response.total

                setPagination(p)
                setData(response.records)
            }
        })
    }

    const summaryFetch = ({ fetchOtherParams }: { fetchOtherParams: object }) => {
        setLoading(true)

        axiosTable.get('/yuesao_center/manage/archives/summary', {
            params: {
                ...fetchOtherParams
            }

        }).then((response: any) => {
            if (response) {
                setData2(response)
            }

            setLoading(false)
        })
    }

    const resetForm = () => {
        setFetchOtherParams(fetchOtherParamsTmpl)

        let p: any = { ...pagination }
        p.current = 1

        setPagination(p)
        fetch({ pagination: p, fetchOtherParams: fetchOtherParamsTmpl })
        summaryFetch({ fetchOtherParams: fetchOtherParamsTmpl })
    }

    return (<div className="common-page">
        {/* 月嫂中心 -> 月嫂管理 -> 月嫂档案 */}
        <BreadCrumb position={['月嫂中心', '月嫂档案']} />

        <div className="common-top-form">
            <Space direction="horizontal" wrap>
                <div style={{ marginRight: 8, marginBottom: 12 }}>
                    <SelectStores placeholder="服务门店" value={fetchOtherParams.store_id} onChange={(value: string) => { handleChange(value, 'store_id') }} />
                </div>

                <Input style={{ marginRight: 8, marginBottom: 12, width: '150px' }} placeholder="员工名称" value={fetchOtherParams.user_name} onChange={(e: { target: { value: string } }) => { handleChange(e.target.value, 'user_name') }} />
                <Input style={{ marginRight: 8, marginBottom: 12, width: '150px' }} placeholder="员工手机号" value={fetchOtherParams.phone} onChange={(e: { target: { value: string } }) => { handleChange(e.target.value, 'phone') }} />

                <Select allowClear style={{ marginRight: 8, marginBottom: 12, width: 120 }} placeholder="员工类型" value={fetchOtherParams.in_out} onChange={(value: number) => { handleChange(value, 'in_out') }}  >
                    <Option value="1">内部员工</Option>
                    <Option value="2">合作商员工</Option>
                </Select>
                <Select allowClear style={{ marginRight: 8, marginBottom: 12, width: 250 }} placeholder="合作商" value={fetchOtherParams.coperation_id} onChange={(value: string) => { handleChange(value, 'coperation_id') }}  >
                    {coperationList.map((item: any) => {
                        return <Option value={item.coperation_id} key={item.coperation_id}>{item.coperation_name}</Option>
                    })}
                </Select>

                <Select allowClear style={{ marginRight: 8, marginBottom: 12, width: 100 }} placeholder="员工状态" value={fetchOtherParams.status} onChange={(value: number) => { handleChange(value, 'status') }}  >
                    <Option value="1">在职</Option>
                    <Option value="2">离职</Option>
                </Select>
                <Select allowClear style={{ marginRight: 8, marginBottom: 12, width: 160 }} placeholder="工作状态" value={fetchOtherParams.work_status} onChange={(value: number) => { handleChange(value, 'work_status') }}  >
                    <Option value="1">待岗</Option>
                    <Option value="2">医院陪护</Option>
                    <Option value="3">托管</Option>
                    <Option value="4">一对一</Option>
                    <Option value="5">到家（医院陪护）</Option>
                    <Option value="6">到家服务</Option>
                </Select>
            </Space>

            <div style={{ marginTop: 10 }}>
                {permission.includes('查询') && <Button style={{ marginRight: 12, marginBottom: 12 }} className="search-btn" icon={<SearchOutlined />} onClick={handleSearch}>查询</Button>}
                <Button style={{ marginRight: 12, marginBottom: 12 }} onClick={resetForm} icon={<RedoOutlined />}>重置</Button>
                {permission.includes('添加') && <Button style={{ marginRight: 12, marginBottom: 12 }} type="primary" ><Link to={"/yuesao_archives_add"}>添加</Link></Button>}
            </div>
        </div>

        <div className="common-main">
            <Table dataSource={data} scroll={{ x: 'max-content' }} bordered={true} rowKey="id" pagination={pagination} onChange={handleTableChange}>
                <Column
                    fixed
                    title="操作"
                    key="action"
                    render={(text, record: any) => (
                        <Space size="middle">
                            {permission.includes('编辑') && <Button size="small" type="primary" ><Link to={"/yuesao_archives_edit/" + record.id}>编辑</Link></Button>}
                        </Space>
                    )}
                />
                <Column fixed title="服务门店" dataIndex="store_name" key="store_name" />

                <Column fixed title="员工姓名" dataIndex="user_name" key="user_name" />
                <Column fixed title="员工手机号" dataIndex="phone" key="phone" />

                <Column title="员工类型" dataIndex="in_out_desc" key="in_out_desc" />
                <Column title="合作商" dataIndex="coperation_name" key="coperation_name" />

                <Column
                    title="形象照"
                    key="head_pic_url"
                    render={(text, record: any) => (
                        <Space size="middle">
                            <Button type="link" onClick={() => (handleUrl(record, '1'))}>查看</Button>
                        </Space>
                    )}
                />
                <Column
                    title="证书照片"
                    key="cert_pic_url"
                    render={(text, record: any) => (
                        <Space size="middle">
                            <Button type="link" onClick={() => (handleUrl(record, '2'))}>查看</Button>
                        </Space>
                    )}
                />
                <Column
                    title="健康证照片"
                    key="check_report_url"
                    render={(text, record: any) => (
                        <Space size="middle">
                            <Button type="link" onClick={() => (handleUrl(record, '3'))}>查看</Button>
                        </Space>
                    )}
                />
                <Column
                    title="月子餐照片"
                    key="service_diet_url"
                    render={(text, record: any) => (
                        <Space size="middle">
                            <Button type="link" onClick={() => (handleUrl(record, '4'))}>查看</Button>
                        </Space>
                    )}
                />
                <Column
                    title="月子服务图片"
                    key="service_photo_url"
                    render={(text, record: any) => (
                        <Space size="middle">
                            <Button type="link" onClick={() => (handleUrl(record, '5'))}>查看</Button>
                        </Space>
                    )}
                />

                <Column title="工作状态" dataIndex="work_status_desc" key="work_status_desc" />
                <Column title="员工状态" dataIndex="status_desc" key="status_desc" />
                <Column title="入职日期" dataIndex="in_date" key="in_date" />
                <Column title="离职日期" dataIndex="out_date" key="out_date" />

                <Column title="工作经验" dataIndex="work_years_type_desc" key="work_years_type_desc" />
                <Column title="当前星级" dataIndex="star_level_name" key="star_level_name" />
                <Column title="是否可晋级" dataIndex="is_promoted_desc" key="is_promoted_desc" />
                <Column title="累计服务次数" dataIndex="total_service_num" key="total_service_num" />
                <Column title="累计服务天数" dataIndex="total_service_days" key="total_service_days" />

                <Column title="创建人" dataIndex="create_user_name" key="create_user_name" />
                <Column title="创建时间" dataIndex="create_time" key="create_time" />
                <Column title="更新人" dataIndex="update_user_name" key="update_user_name" />
                <Column title="更新时间" dataIndex="update_time" key="update_time" />
            </Table>
        </div>

        <div className="common-main">
            <h3>汇总</h3>

            <Table loading={loading} dataSource={data2} scroll={{ x: 'max-content' }} bordered={true} pagination={false}>
                <Column title="服务门店" dataIndex="store_name" key="store_name" />
                <Column title="员工总数" dataIndex="employee_total_num" key="employee_total_num" />
                <Column title="自有员工总数" dataIndex="internal_employee_num" key="internal_employee_num" />
                <Column title="合作员工总数" dataIndex="partner_employee_num" key="partner_employee_num" />
                <Column title="在职员工数（自有）" dataIndex="internal_employee_current_num" key="internal_employee_current_num" />
                <Column title="离职员工数（自有）" dataIndex="internal_employee_depart_num" key="internal_employee_depart_num" />
                <Column title="待岗员工数（自有）" dataIndex="internal_employee_await_num" key="internal_employee_await_num" />
                <Column title="上单员工数（自有）" dataIndex="internal_employee_duty_num" key="internal_employee_duty_num" />
                <Column title="在职员工数（合作）" dataIndex="partner_employee_current_num" key="partner_employee_current_num" />
                <Column title="离职员工数（合作）" dataIndex="partner_employee_depart_num" key="partner_employee_depart_num" />
                <Column title="待岗员工数（合作）" dataIndex="partner_employee_await_num" key="partner_employee_await_num" />
                <Column title="上单员工数（合作）" dataIndex="partner_employee_duty_num" key="partner_employee_duty_num" />
            </Table>
        </div>

        {/* 图片预览 */}
        <CheckImgs tinyURL={imageList} visible={imageVisble} onCancel={() => { setImageVisble(false) }} />
    </div>)
}